import { render, staticRenderFns } from "./ProductConfiguratorSize.vue?vue&type=template&id=2a4ca382&scoped=true&"
import script from "./ProductConfiguratorSize.vue?vue&type=script&lang=js&"
export * from "./ProductConfiguratorSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4ca382",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a4ca382')) {
      api.createRecord('2a4ca382', component.options)
    } else {
      api.reload('2a4ca382', component.options)
    }
    module.hot.accept("./ProductConfiguratorSize.vue?vue&type=template&id=2a4ca382&scoped=true&", function () {
      api.rerender('2a4ca382', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/Components/ProductConfiguratorSize.vue"
export default component.exports